import React from 'react';
import { RecipientInfoContainer } from './components-styles';
import { CommonButton } from '@Components';
import { IStore } from '../../../../../store.type';
import { connect } from 'react-redux';
import { IRecipientInfoModalProps } from '../../../utils/interface';

const RecipientInfoModal: React.FC<IRecipientInfoModalProps> = ({
  onClose,
  name,
  country,
  accountNumber,
  bankName,
  swiftCode
}) => {
  return (
    <RecipientInfoContainer>
      <div className="info-row">
        <span className="bold-text">Name</span>
        <span className="__text">{name}</span>
      </div>
      <div className="info-row">
        <span className="bold-text">Country</span>
        <span className="__text">{country}</span>
      </div>
      <div className="info-row">
        <span className="bold-text">Bank name</span>
        <span className="__text">{bankName}</span>
      </div>
      <div className="info-row">
        <span className="bold-text">Account number</span>
        <span className="__text">{accountNumber}</span>
      </div>
      <div className="info-row">
        <span className="bold-text">SWIFT</span>
        <span className="__text">{swiftCode}</span>
      </div>

      <div className="button-container">
        <CommonButton onClick={() => onClose?.(false)} text="Got it" width={418} />
      </div>
    </RecipientInfoContainer>
  );
};
function mapStateToProps(reduxState: IStore) {
  const {
    rootReducer: {
      niumForexReducer: {
        transactionDetails: {
          beneDetails: { name, country, bankName, accountNumber, swiftCode }
        }
      }
    }
  } = reduxState;

  return {
    name,
    country,
    accountNumber,
    bankName,
    swiftCode
  };
}
export default connect(mapStateToProps, {})(RecipientInfoModal);
